import React, { useEffect, useState } from "react"
import { Link, NavLink, Outlet, useParams } from "react-router-dom"
import { all_routes } from "../../../router/all_routes"
import StudentSidebar from "./studentSidebar"
import StudentBreadcrumb from "./studentBreadcrumb"
import StudentModals from "../studentModals"
import { getEnrollmentById, Enrollment } from "../../../../service/enrollment"

export type StudentDetailsOutletContext = {
  enrollment: Enrollment | null
  refetch: () => Promise<void>
}

const StudentDetailsLayout: React.FC = () => {
  const routes = all_routes
  const { id } = useParams()
  const [enrollment, setEnrollment] = useState<Enrollment | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const refetch = async () => {
    if (!id) return
    const data = await getEnrollmentById(id)
    setEnrollment(data)
  }

  useEffect(() => {
    const run = async () => {
      try {
        setLoading(true)
        setError(null)
        await refetch()
      } catch (err) {
        console.error("Failed to load student enrollment", err)
        setError("Failed to load student data")
      } finally {
        setLoading(false)
      }
    }
    run()
  }, [id])

  if (loading) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <StudentBreadcrumb />
          </div>
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "50vh" }}
          >
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  if (error || !enrollment || !id) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <StudentBreadcrumb />
          </div>
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "50vh" }}
          >
            <div className="text-center">
              <i className="ti ti-alert-circle fs-1 text-danger mb-3"></i>
              <h4>{error || "Student not found"}</h4>
              <Link to={routes.studentList} className="btn btn-primary mt-3">
                Back to Student List
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <StudentBreadcrumb />
          </div>
          <div className="row">
            <StudentSidebar data={enrollment} fetchData={refetch} />
            <div className="col-xxl-9 col-xl-8">
              <div className="row">
                <div className="col-md-12">
                  <ul className="nav nav-tabs nav-tabs-bottom mb-4">
                    <li>
                      <NavLink
                        end
                        to={routes.studentDetail.replace(":id", id)}
                        className={({ isActive }) =>
                          `nav-link ${isActive ? "active" : ""}`
                        }
                      >
                        <i className="ti ti-school me-2" />
                        Student Details
                      </NavLink>
                    </li>
                    {/* Additional tabs can be enabled as needed */}
                    <li>
                      <NavLink
                        to="fees"
                        className={({ isActive }) =>
                          `nav-link ${isActive ? "active" : ""}`
                        }
                      >
                        <i className="ti ti-report-money me-2" />
                        Invoices
                      </NavLink>
                    </li>
                    {/* <li>
                      <NavLink
                        to="result"
                        className={({ isActive }) =>
                          `nav-link ${isActive ? "active" : ""}`
                        }
                      >
                        <i className="ti ti-bookmark-edit me-2" />
                        Exam & Results
                      </NavLink>
                    </li> */}
                    {/* <li>
                      <NavLink
                        to="leaves"
                        className={({ isActive }) =>
                          `nav-link ${isActive ? "active" : ""}`
                        }
                      >
                        <i className="ti ti-calendar-due me-2" />
                        Leave & Attendance
                      </NavLink>
                    </li> */}
                    {/* <li>
                      <NavLink
                        to="time-table"
                        className={({ isActive }) =>
                          `nav-link ${isActive ? "active" : ""}`
                        }
                      >
                        <i className="ti ti-table-options me-2" />
                        Time Table
                      </NavLink>
                    </li> */}
                    {/* <li>
                      <NavLink
                        to="library"
                        className={({ isActive }) =>
                          `nav-link ${isActive ? "active" : ""}`
                        }
                      >
                        <i className="ti ti-books me-2" />
                        Library
                      </NavLink>
                    </li> */}
                  </ul>
                  <Outlet context={{ enrollment, refetch }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <StudentModals />
    </>
  )
}

export default StudentDetailsLayout
